import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'
import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import { BootstrapVue } from 'bootstrap-vue'
import messages from './lang'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { SENTRY_API } from './env'
import router from '@/router'
// import Tracker from '@asayerio/tracker'
// const tracker = new Tracker({
//   projectID: 7237634907199555
// })
// tracker.start()
if (SENTRY_API) {
  Sentry.init({
    dsn: SENTRY_API,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })
}

var VueCookie = require('vue-cookie')

Vue.use(VueCookie)
Vue.use(BootstrapVue)
Vue.use(VueI18n)

Vue.config.productionTip = false
Vue.config.performance = true

export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'en',
  messages
})
//
// new Vue({
//   i18n,
//   router,
//   render: h => h(App)
// }).$mount('#app')

window.Office.initialize = function (reason) {
  new Vue({
    i18n,
    router,
    render: h => h(App)
  }).$mount('#app')
}
